import { type NodeProps } from '@xyflow/react'
import React, { type MouseEventHandler, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type IIconProps } from 'shared/ui'
import { FlowActionNode, FlowDeleteActionStore, FlowDropdownButton } from 'widgets/Flow'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'

type IActionNodeProp = {
  iconProps?: IIconProps | null
  title: string
  content: ReactNode
  active?: boolean
  placeholder?: string
  onClick?: MouseEventHandler<HTMLDivElement>
  hideActions?: boolean
  error?: string
} & NodeProps

export const SmartCallActionNode = observer(
  ({ id, onClick, hideActions, ...props }: IActionNodeProp) => {
    const { getActionById, selectedActionStore, setSelectedActionStore, deleteAction } =
      useSmartCallFlowBuilderContext()

    const store = getActionById(id)

    const handleClickCard: MouseEventHandler<HTMLDivElement> = (e) => {
      if (onClick) {
        onClick(e)
        return
      }
      if (!store) return
      setSelectedActionStore(store)
    }

    const isActive = selectedActionStore?.actionStore.id === store?.actionStore.id
    const isError = store && 'isConfigurationError' in store ? store.isConfigurationError : false

    const handleClick = (handler: () => void, setOpen: (value: boolean) => void) => () => {
      handler()
      setOpen(false)
    }

    if (!store) return null

    return (
      <FlowActionNode
        isError={isError}
        isActive={isActive}
        onClick={handleClickCard}
        id={id}
        ActionsContent={
          hideActions
            ? undefined
            : ({ setOpen }) => (
                <>
                  <FlowDropdownButton
                    iconProps={{
                      icon: 'edit',
                      tertiary: true,
                    }}
                    text={'Edit'}
                    onClick={handleClick(() => {
                      setSelectedActionStore(store)
                    }, setOpen)}
                  />
                  <FlowDropdownButton
                    iconProps={{
                      icon: 'delete',
                      tertiary: true,
                    }}
                    text={'Delete'}
                    onClick={handleClick(() => {
                      new FlowDeleteActionStore((isNextDelete) => {
                        deleteAction(store, isNextDelete)
                      })
                    }, setOpen)}
                  />
                </>
              )
        }
        {...props}
      />
    )
  }
)
